import React from 'react';
import { useIntl } from 'react-intl';
import TaskPrompt from '@components/TaskPrompt';
import { usePageTitle } from '@contexts/usePageTitle';
import { PageContainer, MainContent } from './Home.styled';

const HomePage: React.FC = () => {
  const intl = useIntl();
  usePageTitle(
    intl.formatMessage({ id: 'home.title', defaultMessage: 'Home' }),
    intl.formatMessage({
      id: 'home.help',
      defaultMessage:
        'Your starting point — assign a task or ask anything, attach files, or kick off a process, and the AI agent takes it from there.',
    }),
  );

  return (
    <PageContainer>
      <MainContent>
        <TaskPrompt />
      </MainContent>
    </PageContainer>
  );
};

export default HomePage;
